import styled from '@emotion/styled'

export const BankConnectionEmptyModuleContainer = styled.div`
  width: 500px;
  margin: 0 auto;
`
